import React from 'react';

import Tooltip from '../../common/Tooltip';
import { TGlobalWorker } from './types';
import { renderStatus } from './helpers';

export const createGlobalFreelancerColumns = (allowedSortColumns: Set<string>) => [
    {
        Header: 'Ref',
        accessor: 'reference_number',
        headerClassName: 'small-col',
        className: 'small-col',
        sortable: allowedSortColumns.has('reference_number'),
    },
    {
        Header: 'Photo',
        accessor: 'photo_thumbnail_medium',
        sortable: false,
        headerClassName: 'xsmall-col',
        className: 'xsmall-col',
        Cell: ({ original }: { original: TGlobalWorker }) => {
            const workerImg = original.photo_thumbnail_large
                ? original.photo_thumbnail_large
                : '/static/images/default_profile.png';
            return (
                <div>
                    <a
                        className="group-link"
                        href={workerImg}
                        target="_blank"
                        rel="noreferrer"
                    >
                        <div
                            className="avatar"
                            style={{
                                backgroundImage: `url(${workerImg})`,
                            }}
                        />
                    </a>
                </div>
            );
        },
    },
    {
        Header: 'Name',
        accessor: 'full_name',
        Cell: ({ value }: { value: string }) => (
            <span title={value}>{value}</span>
        ),
        sortable: allowedSortColumns.has('full_name'),
    },
    {
        Header: 'Service',
        id: 'service',
        accessor: (row: TGlobalWorker) => row.service_key,
        headerClassName: 'small-col',
        className: 'small-col upper-case',
        sortable: allowedSortColumns.has('service'),
    },
    {
        Header: 'Role(s)',
        accessor: 'service_role',
        Cell: ({ value }: { value: string }) => (
            <Tooltip tooltip={value}>
                <span>{value}</span>
            </Tooltip>
        ),
        sortable: allowedSortColumns.has('service_role'),
    },
    {
        Header: 'Postcode',
        accessor: 'postcode',
        headerClassName: 'small-col',
        className: 'small-col',
        sortable: allowedSortColumns.has('postcode'),
    },
    {
        Header: 'Status',
        accessor: 'published',
        headerClassName: 'xsmall-col',
        className: 'xsmall-col col-center',
        Cell: ({
            value,
            original,
        }: {
            value: boolean | null | undefined;
            original: TGlobalWorker;
        }) => renderStatus(value, original.is_active),
        sortable: allowedSortColumns.has('published'),
    },
    {
        Header: 'Mobile',
        accessor: 'mobile',
        headerClassName: 'medium-col',
        className: 'medium-col',
        Cell: ({ value }: { value: string | null }) => {
            if (!value) {
                return <span>-</span>;
            }
            const mobileLink = `tel:${value}`;
            return (
                <a className="group-link" href={mobileLink}>
                    {value}
                </a>
            );
        },
        sortable: allowedSortColumns.has('mobile'),
    },
    {
        Header: 'Email',
        accessor: 'email',
        sortable: allowedSortColumns.has('email'),
        Cell: ({ value }: { value: string | null }) => {
            if (!value) {
                return <span>-</span>;
            }
            const mailToAddress = `mailto:${value}`;
            return (
                <a className="group-link" href={mailToAddress}>
                    {value}
                </a>
            );
        },
    },
    {
        Header: 'Primary Branch',
        id: 'primary_branch',
        accessor: (row: TGlobalWorker) =>
            row.primary_branch?.company_name || '-',
        sortable: allowedSortColumns.has('primary_branch'),
    },
];
